/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const CopyLight = props => (
  <svg viewBox="0 0 44 44" fill="none" width="1em" height="1em" {...props}>
    <path
      d="M17.407 8.704c0-1.204.973-2.176 2.176-2.176h8.983c.578 0 1.129.231 1.537.64l4.073 4.072c.408.408.64.96.64 1.537v13.335a2.174 2.174 0 01-2.177 2.176H19.583a2.174 2.174 0 01-2.176-2.176V8.704zm2.176-4.352a4.356 4.356 0 00-4.352 4.352v17.408c0 2.4 1.952 4.352 4.352 4.352H32.64c2.4 0 4.352-1.952 4.352-4.352V12.777a4.353 4.353 0 00-1.271-3.08l-4.073-4.073a4.353 4.353 0 00-3.08-1.272h-8.984zm-8.704 8.704a4.356 4.356 0 00-4.352 4.352v17.408c0 2.4 1.952 4.352 4.352 4.352h13.056c2.4 0 4.352-1.952 4.352-4.352v-1.088h-2.176v1.088a2.174 2.174 0 01-2.176 2.176H10.88a2.174 2.174 0 01-2.176-2.176V17.408c0-1.204.973-2.176 2.176-2.176h1.088v-2.176H10.88z"
    />
  </svg>
);
export default extendIcon(CopyLight);

